<template>
<div>
    <mu-appbar title="Chauffeurs" class="syn-navbar">
        <mu-text-field icon="search" hintText="recherche"
            class="appbar-search-field" slot="right"
            @input="searchDriver" />
        <mu-raised-button href="#/driver/ajouter" class="" slot="right" label="Ajouter" icon="add" secondary/>
    </mu-appbar>
    <!-- Tableau -->
    <div class="syn-content">
        <mu-table :selectable="selectable" :showCheckbox="showCheckbox" @rowClick="trRoute" style="border: 1px solid #e1e8e9;">
            <mu-thead>
                <mu-tr>
                    <mu-th @click.native="setOrder('name')" class="pointer">Nom</mu-th>
                    <mu-th @click.native="setOrder('firstname')" class="pointer">Prénom</mu-th>
                    <mu-th>Tel</mu-th>
                    <mu-th @click.native="setOrder('abrege')" class="pointer">Abrege</mu-th>
                    <mu-th>Etat</mu-th>
                </mu-tr>
            </mu-thead>
            <mu-tbody>
                <mu-tr v-for="(item, index) in driver" :key="index" style="cursor: pointer;">
                    <mu-td>{{item.name}}</mu-td>
                    <mu-td>{{item.firstname}}</mu-td>
                    <mu-td>{{item.tel1}}</mu-td>
                    <mu-td>{{item.abrege}}</mu-td>
                    <mu-td>
                        <mu-badge v-if="item.liv_sta_id=='GEN01'" content="Actif" secondary ></mu-badge>
                        <mu-badge v-else content="Supprimé" color="red" ></mu-badge>
                    </mu-td>
                </mu-tr>
            </mu-tbody>
        </mu-table>
        <mu-pagination :total="pagin.total" :current="pagin.currentPage" @pageChange="handlePage" 
            class="pull-right" style="margin: 10px; border: 1px solid #d8e1e3; background-color:#fff;">
        </mu-pagination><div style="margin: 10px;">Résultats : {{pagin.total}}</div>
    </div>
</div>
</template>

<script>
import icon       from 'muse-components/icon'
import iconButton from 'muse-components/iconButton'
import appBar     from 'muse-components/appBar'
import flatButton from 'muse-components/flatButton'
import textField  from 'muse-components/textField'
import raisedButton from 'muse-components/raisedButton'
import {table, thead, tbody, tfoot, tr, td, th }    from 'muse-components/table'
import pagination from 'muse-components/pagination'
import badge      from 'muse-components/badge'

export default {
    name: 'driver',
    data: function () {
        return {
        selectable:false,
        showCheckbox:false,
        pagin: { total: 10, currentPage: 1, limit: 0, order:'ASC', perPage:10, order_by:'' },
        autoProcess: false,
        searchName: '',
        driver: [{
            rowid: '',
            lastname: '',
            firstname: '',
            email: ''
        }]
        }
    },
    methods: {
        getDriver(){
            window.axios.post( '/', { 
                _method:'GET', _path:'driver', 
                name:this.searchName, limit: this.pagin.limit + ',' + this.pagin.perPage,
                order: this.pagin.order, order_by: this.pagin.order_by
            }).then( (response) => {
                if( response.headers.totalrow !== undefined ){
                    this.pagin.total = parseInt(response.headers.totalrow)
                }
                this.driver = []
                this.driver = response.data
            })
        },
        setOrder(order_by){
            if( this.pagin.order === 'ASC' && this.pagin.order_by === order_by ){
                this.pagin.order    = 'DESC'
            } else {
                this.pagin.order    = 'ASC'
            }
            this.pagin.order_by = order_by
            this.getDriver()
        },
        trRoute (index) {
            this.$router.push({ path: '/driver/' + this.driver[index].rowid })
        },
        handlePage (newIndex) {
            this.pagin.limit = (newIndex - 1) * this.pagin.perPage
            this.pagin.currentPage = newIndex
            this.getDriver()
        },
        searchDriver(value){
            if( this.autoProcess ){
                clearTimeout(this.autoProcess)
            }
            if( value.length > 2 || value.length === 0 ){
                this.autoProcess = setTimeout( () => {
                    this.pagin.limit = 0
                    this.pagin.currentPage = 1
                    this.searchName = value
                    this.getDriver()
                }, 1000)
            } else {
                return false
            }
        }
    },
    mounted:function (){
        this.getDriver();
    },
    components: {
        'mu-icon-button': iconButton,
        'mu-appbar': appBar,
        'mu-text-field': textField,
        'mu-flat-button': flatButton,
        'mu-raised-button': raisedButton,
        'mu-table': table,
        'mu-thead': thead,
        'mu-tbody': tbody,
        'mu-tfoot': tfoot,
        'mu-tr': tr,
        'mu-td': td,
        'mu-th': th,
        'mu-pagination': pagination,
        'mu-badge': badge
    }
}
</script>

<style lang="less">
.appbar-search-field {
    margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// Driver.vue?022f5728